<div class="container" style="margin: auto;">
    <div class="text-center mt-5" >
        <img class="mb-5" src="./assets/logo2020w.png">
        <h1 class="mt-5" style="font-family: DINPro;" translate>PLEASE WAIT WHILE WE REDIRECT YOU.</h1>
    </div>
</div>
